// @flow
import styled from "styled-components";
const DefaultContainer = styled.div`
  border-left: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  border-top: 1px solid #eeeeee;
  background-color: white;
  border-radius: 10px;
`;

const DefaultPaddedContainer = styled(DefaultContainer)`
  padding: 20px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12) !important;
`;

const DefaultPaddedContainerNoShadow = styled(DefaultContainer)`
  padding: 20px;
`;

const MinimalContainerBase = styled.div`
  border-left: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  border-top: 1px solid #eeeeee;
  background-color: white;
  border-radius: 0px;
`;

const MinimalContainer = styled(MinimalContainerBase)`
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12) !important;
`;

const DataTable = styled.table.attrs({ className: "table table-condensed" })`
  tr th {
    border-right: 1px solid #eee;
    text-decoration: uppercase;
    font-weight: bold;
    background-color: #fbfbfb;
    color: #636363 !important;
    text-transform: uppercase;
    vertical-align: middle !important;
    text-align: center !important;
    padding: 10px 8px !important;
  }

  tr td {
    background-color: white;
  }

  tr:hover td {
    background-color: #fafafa;
  }

  tr.selectedDate td {
    background-color: #d9ffa8;
  }
`;

export {
  DefaultContainer,
  DefaultPaddedContainer,
  DefaultPaddedContainerNoShadow,
  MinimalContainer,
  DataTable
};
